import { render } from "./VerticalList.vue?vue&type=template&id=3b9e36ce"
import script from "./VerticalList.vue?vue&type=script&lang=js"
export * from "./VerticalList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__